import styled from "styled-components";

// ** Pickup/Delivery Input ** //
export const FulfillmentLabel = styled.label`
`

export const Fulfillment = styled.span`
`

export const FulfillmentInput = styled.input`

`